import React from 'react';
import clsx from 'clsx';
import { useStyles } from './styles';
const StatusTile = ({ classes, status }) => {
    const ownClasses = useStyles();
    return React.createElement("div", { className: clsx(ownClasses.root, ownClasses[status], classes?.root) });
};
export default StatusTile;
